import entryFactory from 'bpmn-js-properties-panel/lib/factory/EntryFactory'

import cmdHelper from 'bpmn-js-properties-panel/lib/helper/CmdHelper'
import store from '@/store'

import $ from 'jquery'
import axios from 'axios'

export default function(element, bpmnFactory, options, translate) {
  let SelectedHiveType = ''
  let SelectedHive = ''
  let ShowMatchingBots = true
  let SearchBotString = ''
  let PageSize = 10
  let BotList = []
  let BPMN = null
  let BotLoading = false
  let RefreshBots = false

  async function fillBots() {
    BotLoading = true
    if (
      SelectedHive !== null &&
      SelectedHive !== undefined &&
      SelectedHive !== ''
    ) {
      let bpmnId = null
      //get url path
      let path = window.location.pathname
      // get the last part of the url path
      if (BPMN === null) {
        let workflowId = path.split('/').pop()
        //Check if last part is UUID
        if (workflowId.length === 36) {
          //   get workflow from store
          let response = await axios.get(`/api/v1/workflows/${workflowId}`)
          let workflow = response.data
          if (workflow) {
            BPMN = workflow.bpmnId || ''
          }
        }
      }
      let urlParams = `?page=1&size=${PageSize}&sort=changedAt,desc&active=true`
      urlParams = urlParams + '&hiveId=' + SelectedHive
      if (BPMN && BPMN !== '' && ShowMatchingBots) {
        urlParams = urlParams + '&bpmnId=' + BPMN
      }
      if (SearchBotString && SearchBotString !== '') {
        urlParams = urlParams + '&search=' + SearchBotString
      }
      let response = await axios.get(`/api/v1/bots${urlParams}`)
      if (response.data._embedded) {
        BotList = response.data._embedded.bots
      } else {
        BotList = []
      }
    }
    BotLoading = false
  }

  let selectHiveType = entryFactory.selectBox({
    id: 'hiveType',
    label: 'Please select the Hive type',
    selectOptions: [
      { value: undefined, name: 'Select a Hive type' },
      { value: 'SAP', name: 'Tulip SAP Agent' },
      { value: 'API', name: 'Tulip REST API Agent' },
      { value: 'RPA', name: 'Tulip Windows RPA Agent' },
      { value: 'JAVA', name: 'Tulip Server Agent (Java)' },
      { value: 'NECTAR', name: 'Nectar Services' }
    ],
    modelProperty: 'hiveType',
    emptyParameter: false,
    set: function(element, values, node) {
      SelectedHiveType = values.hiveType
      SelectedHive = ''
      let bo = element.businessObject
      let prop = {}
      prop['hiveType'] = SelectedHiveType
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      SelectedHiveType = bo.get('hiveType')
      return {
        hiveType: SelectedHiveType,
        label: 'Please select the Hive type'
      }
    }
  })

  let selectHive = entryFactory.selectBox({
    id: 'hive',
    label: 'Please select the Hive',
    selectOptions: function(element, node) {
      let hives = []
      hives.push({ value: undefined, name: 'Select a Hive' })
      if (
        SelectedHiveType !== null &&
        SelectedHiveType !== undefined &&
        SelectedHiveType !== ''
      ) {
        let objArray = store.getters.getHives.map(hive => {
          if (hive.hiveType === SelectedHiveType) {
            return hive
          }
        })
        for (let i = 0; i < objArray.length; i++) {
          let item = objArray[i]
          if (item) {
            hives.push({ value: item.hexId, name: item.description })
          }
        }
      }
      return hives
    },
    setControlValue: true,
    modelProperty: 'hive',
    emptyParameter: false,
    set: function(element, values, node) {
      SelectedHive = values.hive
      let bo = element.businessObject
      let prop = {}
      prop['hive'] = SelectedHive
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      SelectedHive = bo.get('hive')
      return {
        hive: SelectedHive,
        label: 'Please select the Hive'
      }
    }
  })

  let showMatchingBots = entryFactory.checkbox({
    id: 'showMatchingBots',
    label: ' Show only the related Bots by BPMN Identifier',
    modelProperty: 'showMatchingBots',
    get: function(element, node) {
      showMatchingBots = ShowMatchingBots
      return {
        showMatchingBots: ShowMatchingBots
      }
    },
    set: function(element, values, node) {
      ShowMatchingBots = values.showMatchingBots
      fillBots()
    }
  })

  let pageSize = entryFactory.selectBox({
    id: 'pageSize',
    label: 'Please select the page size',
    selectOptions: [
      { value: 10, name: '10' },
      { value: 20, name: '20' },
      { value: 50, name: '50' }
    ],
    modelProperty: 'pageSize',
    get: function(element, values, node) {
      pageSize = PageSize
      return {
        pageSize: pageSize,
        label: 'Please select the page size'
      }
    },

    set: function(element, values, node) {
      PageSize = values.pageSize
    }
  })

  let searchBots = entryFactory.textField({
    id: 'searchBots',
    label: 'Search Bots by name or description',
    modelProperty: 'searchBots',

    get: function(element, values, node) {
      searchBots = SearchBotString
      return {
        searchBots: searchBots,
        label: 'Search Bots by name or description'
      }
    },

    set: function(element, values, node) {
      SearchBotString = values.searchBots
      fillBots()
    }
  })

  // let refreshBots = entryFactory.link({
  //   id: 'refreshBotLink',
  //   label: 'Refresh Bots',
  //   modelProperty: 'refreshBots',
  //   showLink: function() {
  //     return true
  //   },
  //   handleClick: function(element, node) {
  //     fillBots()
  //     let bo = element.businessObject
  //     let prop = {}
  //     prop['searchBots'] = true
  //     return cmdHelper.updateBusinessObject(element, bo, prop)
  //   }
  // })

  let refreshBots = entryFactory.checkbox({
    id: 'refreshBots',
    label:
      'Try toggle back and forth to refresh the Bot List, *The list is lazy loaded',
    modelProperty: 'refreshBots',
    get: function(element, node) {
      refreshBots = RefreshBots
      return {
        refreshBots: refreshBots
      }
    },
    set: function(element, values, node) {
      RefreshBots = values.refreshBots
      fillBots()
    }
  })

  let selectBot = entryFactory.selectBox({
    id: 'bot',
    label: 'Please select the Bot',
    selectOptions: function(element, node) {
      let bots = []
      if (BotList.length > 0) {
        bots.push({ value: undefined, name: 'Select a Bot' })
        for (let i = 0; i < BotList.length; i++) {
          let item = BotList[i]
          bots.push({ value: item.hexId, name: item.name })
        }
      }

      let bo = element.businessObject
      let bot = bo.get('bot')
      let botName = bo['name']
      if (bot !== null && bot !== undefined && bot !== '') {
        let item = bots.find(x => x.value === bot)
        if (item === null || item === undefined || item === '') {
          bots.push({ value: bot, name: botName })
        }
      }
      return bots
    },
    setControlValue: true,
    modelProperty: 'bot',
    emptyParameter: false,
    set: function(element, values, node) {
      let bo = element.businessObject
      let prop = {}
      prop['bot'] = values.bot
      let nodeXML =
        '<?xml version="1.0" encoding="utf-8"?><bot>' +
        node.innerHTML +
        '</bot>'
      let xmlDoc = $.parseXML(nodeXML)
      let $xml = $(xmlDoc)
      prop['name'] =
        $xml.find('option[value="' + values.bot + '"]').text() || 'Bot'
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      let bot = bo.get('bot')
      return {
        bot: bot,
        label: 'Please select the Bot'
      }
    }
  })

  return [
    selectHiveType,
    selectHive,
    showMatchingBots,
    pageSize,
    searchBots,
    selectBot,
    refreshBots
  ]
}
